import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2a7f879a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=2a7f879a&lang=scss&scoped=true"
import style1 from "./index.vue?vue&type=style&index=1&id=2a7f879a&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7f879a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zhenzhaopin\\xxh-zhaopin-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a7f879a')) {
      api.createRecord('2a7f879a', component.options)
    } else {
      api.reload('2a7f879a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2a7f879a&scoped=true", function () {
      api.rerender('2a7f879a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/aiChat/index.vue"
export default component.exports